import { Link } from 'react-router';
import { Home, ArrowLeft, Search } from 'lucide-react';

/**
 * NotFound - Página 404 exibida para rotas não reconhecidas.
 * Usa exclusivamente variáveis CSS do design system.
 */
export function NotFound() {
  return (
    <div
      className="flex flex-col items-center justify-center"
      style={{
        minHeight: '60vh',
        fontFamily: 'var(--font-family-inter)',
        padding: '24px',
      }}
    >
      <div
        className="flex flex-col items-center gap-6 p-8 w-full"
        style={{
          maxWidth: '480px',
          backgroundColor: 'var(--card)',
          borderRadius: 'var(--radius-card)',
          border: '1px solid var(--border)',
          boxShadow: 'var(--elevation-sm)',
        }}
      >
        {/* Icon */}
        <div
          className="flex items-center justify-center"
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: 'var(--destructive-muted)',
            color: 'var(--warning)',
          }}
        >
          <Search size={40} />
        </div>

        {/* Code */}
        <p
          style={{
            fontSize: 'var(--text-6xl)',
            fontWeight: 'var(--font-weight-semibold)',
            fontFamily: 'var(--font-family-mono)',
            color: 'var(--primary)',
            lineHeight: '1',
            letterSpacing: '-2px',
          }}
        >
          404
        </p>

        {/* Message */}
        <div className="text-center">
          <h2
            style={{
              fontWeight: 'var(--font-weight-semibold)',
              fontSize: 'var(--text-lg)',
              color: 'var(--foreground)',
              marginBottom: '8px',
            }}
          >
            Pagina nao encontrada
          </h2>
          <p
            style={{
              color: 'var(--muted-foreground)',
              fontSize: 'var(--text-sm)',
              lineHeight: '1.6',
            }}
          >
            A pagina que voce procura nao existe ou foi movida. 
            Verifique o endereco ou volte ao inicio.
          </p>
        </div>

        {/* Actions */}
        <div className="flex gap-3 w-full">
          <button
            onClick={() => window.history.back()}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-3 transition-opacity hover:opacity-80"
            style={{
              backgroundColor: 'var(--muted)',
              color: 'var(--foreground)',
              borderRadius: 'var(--radius-button)',
              border: 'none',
              cursor: 'pointer',
              fontFamily: 'var(--font-family-inter)',
              fontSize: 'var(--text-sm)',
              fontWeight: 'var(--font-weight-medium)',
            }}
          >
            <ArrowLeft size={16} />
            Voltar
          </button>
          <Link
            to="/"
            className="flex-1 flex items-center justify-center gap-2 px-4 py-3 transition-opacity hover:opacity-90"
            style={{
              backgroundColor: 'var(--primary)',
              color: 'var(--primary-foreground)',
              borderRadius: 'var(--radius-button)',
              textDecoration: 'none',
              fontFamily: 'var(--font-family-inter)',
              fontSize: 'var(--text-sm)',
              fontWeight: 'var(--font-weight-semibold)',
            }}
          >
            <Home size={16} />
            Inicio
          </Link>
        </div>
      </div>
    </div>
  );
}
